

define(['jquery', 'angular', 'squid/index'], function ($, angular, squid) {

    (function exportProviders(angular) {
        angular && angular.exportProviders(module, exports, __dirname, __filename);
    })(window.angular);

    squid.module('xo-login.capeUtil', ['squid']).factory('$capeRedirectUtil', function ($util, $CreditDataModel, $state) {
        return {
            handleCapeRouting: function handleCapeRouting(checkoutSession, token) {
                var fundingInstruments = checkoutSession.fundingOptions && checkoutSession.fundingOptions.instruments;
                var isCreditInWallet = fundingInstruments && $util.find(fundingInstruments, function (fi) {
                    return fi.type === 'CREDIT';
                });

                var creditDataModel = $CreditDataModel.instance(token);
                var isCapeReturnKey = creditDataModel.getCapeKey();

                // User does not have any FI in wallet but they choose to pay in full.
                // Show add card contingency page instead of redirecting to CAPE.
                if (checkoutSession.isCreditPromoted && creditDataModel.payInFull) {
                    return $state.go('checkout.pageAddCard.addCardFlow.addCard');
                }

                // Handle case where it was timeout and status is to go back to cape
                else if (isCreditInWallet || isCapeReturnKey || creditDataModel.payInFull) {
                        return $state.go('checkout.review');
                    }

                    // Handle "checkout with paypal" link on cyco
                    else if (!isCreditInWallet && (checkoutSession.creditOffer || checkoutSession.bmlOffer)) {
                            return $state.go('checkout.redirectToCape');
                        } else {
                            // show error message
                            return $state.go('checkout.review');
                        }
            }
        };
    });
});


/*****************
 ** WEBPACK FOOTER
 ** ./pages/xo-login/util.js
 ** module id = 184
 ** module chunks = 1
 **/